import * as Types from '../../../../types.generated';

import { gql } from '@apollo/client';
import { MediaFragmentDoc, ConvertMediaToRichTextDocumentWorkflowFragmentDoc } from '../../../../fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StartMediaToRichTextDocumentConversionMutationVariables = Types.Exact<{
  input: Types.StartTrainingResourceMediaToRichTextDocumentConversionInput;
}>;


export type StartMediaToRichTextDocumentConversionMutation = { __typename?: 'Mutation', startTrainingResourceMediaToRichTextDocumentConversion: { __typename?: 'TrainingResourceMutationResult', success: boolean, trainingResource?: { __typename?: 'TrainingResource', id: string, draftVersion: { __typename?: 'TrainingResourceVersion', id: string, media?: { __typename?: 'Media', id: number, loopVideo: boolean, hideVideoControls: boolean, unoptimizedUrl?: string | null, createdAt: string, updatedAt: string, thumbnailImageUrl?: string | null, mostRecentConvertMediaToRichTextDocumentWorkflow?: { __typename?: 'ConvertMediaToRichTextDocumentWorkflow', id: string, conversionStatus?: { __typename?: 'MediaConversionStatus', id: string, failedAt?: string | null, succeededAt?: string | null } | null, richTextDocuments?: Array<{ __typename?: 'RichTextDocument', id: string }> | null } | null, aiEditSource?: { __typename?: 'Media', id: number, mediaUrls: { __typename?: 'TranslationSet', en: string } } | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null, trainingResourceVersions?: Array<{ __typename?: 'TrainingResourceVersion', id: string, trainingResource: { __typename?: 'TrainingResource', id: string, libraryItem: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } } }> | null } | null } } | null } };

export type TrainingResourceBuildRightPane_MediaQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type TrainingResourceBuildRightPane_MediaQuery = { __typename?: 'Query', Media?: { __typename?: 'Media', id: number, loopVideo: boolean, hideVideoControls: boolean, unoptimizedUrl?: string | null, createdAt: string, updatedAt: string, thumbnailImageUrl?: string | null, subtitleTracks: Array<{ __typename?: 'SubtitleTrack', id: string, language: Language, subtitleSegments: Array<{ __typename?: 'SubtitleSegment', id: string, index: number, text: string, startTime: number, endTime: number }> }>, aiEditSource?: { __typename?: 'Media', id: number, mediaUrls: { __typename?: 'TranslationSet', en: string } } | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null, trainingResourceVersions?: Array<{ __typename?: 'TrainingResourceVersion', id: string, trainingResource: { __typename?: 'TrainingResource', id: string, libraryItem: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } } }> | null } | null };


export const StartMediaToRichTextDocumentConversionDocument = gql`
    mutation StartMediaToRichTextDocumentConversion($input: StartTrainingResourceMediaToRichTextDocumentConversionInput!) {
  startTrainingResourceMediaToRichTextDocumentConversion(input: $input) {
    success
    trainingResource {
      id
      draftVersion {
        id
        media {
          id
          ...Media
          mostRecentConvertMediaToRichTextDocumentWorkflow {
            ...ConvertMediaToRichTextDocumentWorkflow
          }
        }
      }
    }
  }
}
    ${MediaFragmentDoc}
${ConvertMediaToRichTextDocumentWorkflowFragmentDoc}`;
export type StartMediaToRichTextDocumentConversionMutationFn = Apollo.MutationFunction<StartMediaToRichTextDocumentConversionMutation, StartMediaToRichTextDocumentConversionMutationVariables>;

/**
 * __useStartMediaToRichTextDocumentConversionMutation__
 *
 * To run a mutation, you first call `useStartMediaToRichTextDocumentConversionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartMediaToRichTextDocumentConversionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startMediaToRichTextDocumentConversionMutation, { data, loading, error }] = useStartMediaToRichTextDocumentConversionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartMediaToRichTextDocumentConversionMutation(baseOptions?: Apollo.MutationHookOptions<StartMediaToRichTextDocumentConversionMutation, StartMediaToRichTextDocumentConversionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartMediaToRichTextDocumentConversionMutation, StartMediaToRichTextDocumentConversionMutationVariables>(StartMediaToRichTextDocumentConversionDocument, options);
      }
export type StartMediaToRichTextDocumentConversionMutationHookResult = ReturnType<typeof useStartMediaToRichTextDocumentConversionMutation>;
export type StartMediaToRichTextDocumentConversionMutationResult = Apollo.MutationResult<StartMediaToRichTextDocumentConversionMutation>;
export type StartMediaToRichTextDocumentConversionMutationOptions = Apollo.BaseMutationOptions<StartMediaToRichTextDocumentConversionMutation, StartMediaToRichTextDocumentConversionMutationVariables>;
export const TrainingResourceBuildRightPane_MediaDocument = gql`
    query TrainingResourceBuildRightPane_Media($id: Int!) {
  Media: AdminMedia(id: $id) {
    id
    ...Media
    subtitleTracks {
      id
      language
      subtitleSegments {
        id
        index
        text
        startTime
        endTime
      }
    }
  }
}
    ${MediaFragmentDoc}`;

/**
 * __useTrainingResourceBuildRightPane_MediaQuery__
 *
 * To run a query within a React component, call `useTrainingResourceBuildRightPane_MediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrainingResourceBuildRightPane_MediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrainingResourceBuildRightPane_MediaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrainingResourceBuildRightPane_MediaQuery(baseOptions: Apollo.QueryHookOptions<TrainingResourceBuildRightPane_MediaQuery, TrainingResourceBuildRightPane_MediaQueryVariables> & ({ variables: TrainingResourceBuildRightPane_MediaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrainingResourceBuildRightPane_MediaQuery, TrainingResourceBuildRightPane_MediaQueryVariables>(TrainingResourceBuildRightPane_MediaDocument, options);
      }
export function useTrainingResourceBuildRightPane_MediaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrainingResourceBuildRightPane_MediaQuery, TrainingResourceBuildRightPane_MediaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrainingResourceBuildRightPane_MediaQuery, TrainingResourceBuildRightPane_MediaQueryVariables>(TrainingResourceBuildRightPane_MediaDocument, options);
        }
export type TrainingResourceBuildRightPane_MediaQueryHookResult = ReturnType<typeof useTrainingResourceBuildRightPane_MediaQuery>;
export type TrainingResourceBuildRightPane_MediaLazyQueryHookResult = ReturnType<typeof useTrainingResourceBuildRightPane_MediaLazyQuery>;
export type TrainingResourceBuildRightPane_MediaQueryResult = Apollo.QueryResult<TrainingResourceBuildRightPane_MediaQuery, TrainingResourceBuildRightPane_MediaQueryVariables>;